import api from "./api";

export type FirmaReciboPeriodo = {
  id: number;
  anho: number | null;
  mes: number | null;
  etiqueta: string;
};

export type FirmaReciboEstado = {
  bloqueado: boolean;
  firmado: boolean;
  periodo: FirmaReciboPeriodo | null;
  fecha_firma: string | null;
  mensaje: string;
};

// Estado de la firma del recibo de salario del usuario autenticado.
// Si RRHH tiene un periodo de firma vigente y todavía no marcó la firma del
// colaborador, `bloqueado` viene en true y la app no debe mostrar los recibos.
export const obtenerEstadoFirmaRecibo = async (): Promise<FirmaReciboEstado> => {
  const { data } = await api.get<FirmaReciboEstado>("firma-recibo/estado");

  return {
    bloqueado: Boolean(data?.bloqueado),
    firmado: data?.firmado !== false,
    periodo: data?.periodo ?? null,
    fecha_firma: data?.fecha_firma ?? null,
    mensaje: data?.mensaje ?? "",
  };
};

export default { obtenerEstadoFirmaRecibo };
